module.exports = __webpack_public_path__ + "img/sjz.4286703c.jpg";